import type { BadgeColor } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { OPPORTUNITY_STATUS_IDS, OPPORTUNITY_TASK_STATUS_IDS, SALESFORCE_PROJECT_MEMBER_TYPE_IDS } from 'shared'

const { OPEN, IN_PROGRESS, ON_HOLD, CANCELLED, COMPLETED } = OPPORTUNITY_TASK_STATUS_IDS
const { OPEN: OPP_OPEN, CLOSE, PENDING, SQL_REGISTERED, DUPLICATE, SFA_NON_SQL, GROUP_COMPANY } = OPPORTUNITY_STATUS_IDS
const { CAPTAIN, SERVICE_MANAGER, ACCOUNT_MANAGER, PROJECT_MANAGER, SALES_MEMBER } = SALESFORCE_PROJECT_MEMBER_TYPE_IDS

/** カラーカテゴリの定数 */
export const COLOR_CATEGORY = {
  TASK_STATUS: 'taskStatus',
  OPPORTUNITY_STATUS: 'opportunityStatus',
  ROLE: 'role',
  SEARCH_TOKEN: 'searchToken',
  INCENTIVE_FILTER: 'incentiveFilter',
} as const

/**
 * カラーマップの統合レジストリ
 * - key: カテゴリ名
 * - map: キーと色の対応表
 * - defaultColor: マップに該当がない場合のフォールバック色
 */
const colorRegistry = {
  [COLOR_CATEGORY.TASK_STATUS]: {
    map: {
      [OPEN]: 'red',
      [IN_PROGRESS]: 'blue',
      [ON_HOLD]: 'amber',
      [CANCELLED]: 'gray',
      [COMPLETED]: 'green',
    } as Record<number, BadgeColor>,
    defaultColor: 'gray' as BadgeColor,
  },
  [COLOR_CATEGORY.OPPORTUNITY_STATUS]: {
    map: {
      [OPP_OPEN]: 'blue',
      [CLOSE]: 'gray',
      [PENDING]: 'amber',
      [SQL_REGISTERED]: 'green',
      [DUPLICATE]: 'amber',
      [SFA_NON_SQL]: 'red',
      [GROUP_COMPANY]: 'lime',
    } as Record<number, BadgeColor>,
    defaultColor: 'gray' as BadgeColor,
  },
  [COLOR_CATEGORY.ROLE]: {
    map: {
      [CAPTAIN]: 'orange',
      [SERVICE_MANAGER]: 'green',
      [ACCOUNT_MANAGER]: 'teal',
      [PROJECT_MANAGER]: 'blue',
      [SALES_MEMBER]: 'amber',
    } as Record<number, BadgeColor>,
    defaultColor: 'gray' as BadgeColor,
  },
  [COLOR_CATEGORY.SEARCH_TOKEN]: {
    map: {
      customer: 'lime',
      vertical_division: 'lime',
      lateral_division: 'lime',
      created_by: 'lime',
      sales_recording_group: 'cyan',
      opportunity_status_id: 'cyan',
      opportunity_type: 'violet',
      exclude: 'destructive',
      query: 'secondary',
    } as Record<string, BadgeColor>,
    defaultColor: 'gray' as BadgeColor,
  },
  [COLOR_CATEGORY.INCENTIVE_FILTER]: {
    map: {
      target: 'green',
      disabled: 'gray',
    } as Record<string, BadgeColor>,
    defaultColor: 'gray' as BadgeColor,
  },
}

type ColorCategory = keyof typeof colorRegistry

/** カテゴリとキーを指定してBadgeColorを取得する */
export function getColor(category: ColorCategory, key: string | number | null | undefined): BadgeColor {
  if (key == null) return colorRegistry[category].defaultColor
  const entry = colorRegistry[category]
  return (entry.map as Record<string | number, BadgeColor>)[key] ?? entry.defaultColor
}
